import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wa-preview-row" }
const _hoisted_2 = { class: "wa-preview-col" }
const _hoisted_3 = { class: "wa-preview-bubble" }
const _hoisted_4 = {
  key: 0,
  class: "wa-preview-header"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "wa-preview-footer"
}
const _hoisted_7 = {
  key: 0,
  class: "wa-preview-chips"
}
const _hoisted_8 = {
  key: 1,
  class: "wa-preview-list"
}
const _hoisted_9 = {
  type: "button",
  class: "wa-preview-chip wa-preview-chip--trigger"
}
const _hoisted_10 = { class: "wa-preview-list-panel" }
const _hoisted_11 = {
  key: 0,
  class: "wa-preview-list-section-title"
}
const _hoisted_12 = { class: "wa-preview-list-row-title" }
const _hoisted_13 = {
  key: 0,
  class: "wa-preview-list-row-desc"
}
const _hoisted_14 = {
  key: 2,
  class: "wa-preview-location"
}

import type { Interactive } from '@/types/Interactive';


export default /*@__PURE__*/_defineComponent({
  __name: 'InteractiveMessagePreview',
  props: {
    message: {},
    formattedMessage: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "wa-preview-bubble-tail" }, null, -1)),
        (__props.message.header)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.message.header.text), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "wa-preview-body",
          innerHTML: __props.formattedMessage
        }, null, 8, _hoisted_5),
        (__props.message.footer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.message.footer.text), 1))
          : _createCommentVNode("", true)
      ]),
      (__props.message.type === 'button')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.action?.buttons, (button, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "wa-preview-chip"
              }, [
                _cache[1] || (_cache[1] = _createElementVNode("em", { class: "fas fa-reply" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(button.reply?.title), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.message.type === 'list')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(__props.message.action?.button || 'Select an option'), 1),
              _cache[2] || (_cache[2] = _createElementVNode("em", { class: "fas fa-chevron-down" }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.action?.sections, (section, sectionIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sectionIdx,
                  class: "wa-preview-list-section"
                }, [
                  (section.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(section.title), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.rows, (row, rowIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: rowIdx,
                      class: "wa-preview-list-row"
                    }, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(row.title), 1),
                      (row.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(row.description), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.message.type === 'location_request_message')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('wp.actions.share_location')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})